export function applyEmployeeFilters(employees, { selectedDepartment, selectedEmployeeStatus }) {
  return employees.filter(
    (e) =>
      (selectedDepartment === "ALL" || e.department === selectedDepartment) &&
      (selectedEmployeeStatus === "ALL" || e.status === selectedEmployeeStatus)
  );
}